// Kullanıcılar (alt admin / şube yöneticisi) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'users.list';

export const usersListGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Kullanıcılar ekranı nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu ekranda personellerinizden yönetim paneline sınırlı erişimi olan yöneticiler (alt admin) oluşturur, hangi modülleri göreceklerini belirler ve yaptıkları işlemleri izlersiniz. Ekranı yalnız şirketin ana yöneticisi açabilir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Kullanıcılar, Yeni Kullanıcı Ekle'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler'),
    body: t(`${G}.regions.body`, 'Kullanıcı listesi'),
    footer: t(`${G}.regions.footer`, 'Satır işlemleri'),
  },
  navItems: [
    t(`${G}.nav.subAdmins`, 'Yöneticiler'),
    t(`${G}.nav.managers`, 'Şube Yöneticileri'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Yeni kullanıcı ekleyin'),
      text: t(`${G}.s1.text`, '"Yeni Kullanıcı Ekle" penceresinde "Personel Seç" kutusundan bir personeli ad, soyad veya e-posta ile bulun, ardından "Modül Yetkileri" altında erişebileceği modülleri işaretleyip Kaydet deyin. Personel Alt Admin olur ve panelde yalnız işaretlediğiniz modülleri görür.'),
      tips: [
        t(`${G}.s1.tip1`, 'En az bir modül seçmeden kayıt yapılamaz.'),
        t(`${G}.s1.tip2`, 'Modül grupları kenar çubuğundaki başlıklarla aynıdır; grup kutusu o gruptaki tüm alt düğmeleri birlikte seçer veya temizler.'),
        t(`${G}.s1.tip3`, 'Listede yalnız rolü personel veya şube yöneticisi olanlar çıkar. Şube yöneticisini seçerseniz rolü Alt Admin olur ve Şube Yöneticileri sekmesinden çıkar.'),
      ],
    },
    {
      region: 'tabs',
      title: t(`${G}.s2.title`, '2. Sekmeler'),
      text: t(`${G}.s2.text`, '"Yöneticiler" sekmesi alt admin kullanıcılarını, "Şube Yöneticileri" sekmesi şube müdürü olarak atanmış personeli listeler. "Yeni Kullanıcı Ekle" düğmesi yalnız Yöneticiler sekmesinde görünür.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Listeyi okuyun'),
      text: t(`${G}.s3.text`, 'Yöneticiler sekmesinde Kullanıcı, E-posta, İzinli Modüller ve Durum (Aktif / Pasif) görünür. İlk dört modül etiket olarak yazılır; fazlası "+sayı" etiketinin üzerine gelince görünür. "Modül izni yok" yazan kullanıcıya hiçbir modül açılmamıştır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Şube Yöneticileri sekmesinde Kullanıcı, E-posta, Şube ve Durum görünür.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Yetkileri düzenleyin veya kaldırın'),
      text: t(`${G}.s4.text`, 'Kalem simgesi (Yetkileri Düzenle) aynı pencereyi açar; işaretleri değiştirip kaydedin. Kırmızı simge (Kullanıcılığı Kaldır) onay ister; onaylarsanız kullanıcının panel izinleri kapatılır ve rolü personele döner.'),
      tips: [
        t(`${G}.s4.tip1`, 'Kullanıcılığı kaldırmak personel kaydını silmez; kişi personel olarak kalır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. İşlem geçmişini inceleyin'),
      text: t(`${G}.s5.text`, 'Saat simgesi (İşlem Geçmişi) kullanıcının yaptığı işlemleri Tarih, İşlem ve Durum (Başarılı / Başarısız) olarak listeler. Başlangıç ve Bitiş tarihiyle aralığı daraltabilirsiniz.'),
      tips: [
        t(`${G}.s5.tip1`, 'Şube yöneticilerinde bu ekrandan yalnız işlem geçmişi görülür; müdür atama ve müdür yetkileri Şubeler modülünden yapılır.'),
      ],
    },
  ],
});
